{
  "$id": "module://bank-account-purpose",
  "$schema": "wealthlane://schemas/domain",
  "title": "Bank Account Purpose",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "bankAccountPurpose": {
      "type": "string",
      "title": "Account Purpose",
      "widget": "radio",
      "adapterProps": { "layout": "vertical", "hideLabel": true },
      "options": [
        { "label": "Tax Only", "value": "makeTaxAccount" },
        { "label": "Exercise Only", "value": "makeExerciseAccount" },
        { "label": "Both", "value": "both" }
      ]
    }
  }
}
